import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Возникли проблемы?", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Есть вопросы или предложения?", -1)
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_fuel_feedback_form = _resolveComponent("fuel-feedback-form")!
  const _component_carrier_feedback_form = _resolveComponent("carrier-feedback-form")!
  const _component_ui_draggable_wrapper = _resolveComponent("ui-draggable-wrapper")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock(_component_ui_draggable_wrapper, {
    width: 64,
    height: 64,
    right: 24,
    "z-index": 30,
    bottom: $data.bottomOffset,
    "drag-element-id": "feedback-bubble",
    class: _normalizeClass($options.containerStyles),
    "onDrag:stop": _cache[2] || (_cache[2] = ($event: any) => ($data.isDragstop = true))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass($options.actionClasses)
      }, [
        _createElementVNode("div", {
          id: "feedback-bubble",
          class: _normalizeClass(_ctx.$style.iconWrapper),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.open && $options.open(...args)))
        }, [
          _createVNode(_component_svg_icon, {
            name: $options.actionIcon,
            class: _normalizeClass($options.actionIconClasses)
          }, null, 8, ["name", "class"])
        ], 2),
        ($data.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style.content)
            }, [
              _createVNode(_component_svg_icon, {
                name: "close",
                class: _normalizeClass(_ctx.$style.closeIcon),
                onClick: $options.close
              }, null, 8, ["class", "onClick"]),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.top)
              }, [
                _createVNode(_component_svg_icon, {
                  name: "logo_new",
                  class: _normalizeClass(_ctx.$style.iconLogo)
                }, null, 8, ["class"]),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.title)
                }, [
                  (!$data.isSuccessMessageVisible)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.$style.titleText)
                        }, "Здравствуйте", 2),
                        _createElementVNode("img", {
                          src: $data.handImg,
                          alt: "Waving Hand"
                        }, null, 8, _hoisted_1)
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_2, " Запрос успешно отправлен! "))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.text)
                }, [
                  (!$data.isSuccessMessageVisible)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_3,
                        _hoisted_4
                      ], 64))
                    : (_openBlock(), _createElementBlock("p", _hoisted_5, " Ожидайте ответа на электронную почту "))
                ], 2)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.bottom)
              }, [
                ($options.isFuelActive)
                  ? (_openBlock(), _createBlock(_component_fuel_feedback_form, {
                      key: 0,
                      "show-close-button": $data.isSuccessMessageVisible,
                      onSuccess: $options.showSuccessMessage,
                      onClose: $options.close
                    }, null, 8, ["show-close-button", "onSuccess", "onClose"]))
                  : (_openBlock(), _createBlock(_component_carrier_feedback_form, {
                      key: 1,
                      "show-close-button": $data.isSuccessMessageVisible,
                      onSuccess: $options.showSuccessMessage,
                      onClose: $options.close,
                      "onFocus:textArea": _cache[1] || (_cache[1] = ($event: any) => ($data.isSuccessMessageVisible = false))
                    }, null, 8, ["show-close-button", "onSuccess", "onClose"]))
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _: 1
  }, 8, ["bottom", "class"])), [
    [_directive_click_outside, $options.close]
  ])
}